import React from 'react';

import { Card } from '@change/ds-core-ui';

import type { NormalizedLegislativeBody } from '../../hooks/useLegislativeBodiesContainer/types';

import { BodyContent } from './BodyContent';

export const LegislativeBodyCard: React.FC<{
	legislativeBody: NormalizedLegislativeBody;
}> = ({ legislativeBody }) => {
	return (
		<Card className="bg-fill-inverse-strong p-6 shadow-md">
			<BodyContent legislativeBody={legislativeBody} />
		</Card>
	);
};
